module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2",
    attrs: {
      "id": "pre"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780061753923_Contents#rpre"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "3",
      "src": "images/common.jpg",
      "width": "66"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normal4"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("HROUGHOUT THE AGES")]), _vm._v(", tales have been passed down within families, keeping intact oral histories that weld one generation to the next. This is my family’s tale of love, adversity, magic, and wonderment.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Growing up, I was told by my father time and again that a good story could save our life. Then he’d explain to me how he and his sisters had been dying of thirst and hunger as they made their way north from Mexico to the United States during the Mexican Revolution of 1910. “We were ready to lay down and die,” my father told me. “Cannons were blasting all around us. People were screaming and dying. The creeks ran red with blood, but then when the sun went down, your grandmother would brush the snakes and scorpions out of the way with some brush and fix a place for us to sleep for the night. She’d give us a smooth little rock to suck on if we had nothing to eat, and she’d tell us stories about the stars, the moon, the she-fox, and soon we’d forget our hunger and we’d be traveling with her words through a world of wonder.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“God was with us. He was our best friend and He was smiling to us with the stars and the moon, and little by little all our troubles of the day would disappear.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("My father, a big strong man from "), _c('i', [_vm._v("los Altos de Jalisco, ")]), _vm._v("would cry and cry and tell me that his mother, a little old bag of Indian bones, knew a life that few people knew—a life so full of the Holy Breath of the Almighty that no one could ever lose hope. My father told me that they’d go to sleep there in the rocks and dirt, feeling full of hope and love and the complete understanding that tomorrow would be another gift straight from God, and so all would then be possible no matter how harsh their day had been—for life was a dream to live, not a reality to fear.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("This, then, is a history of a people—a tribal heritage, if you will—of my Indian-European ancestors as handed down to me by my father and mother, my aunts and uncles, my cousins and family friends.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Back at one time, we were all Indigenous People, and the time has come to circle back to when the Mother Earth was young, the Heavens spoke, and people listened.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Like my grandmother used to say, there are no strangers, once we get to know each other’s story. Enjoy. "), _c('i', [_vm._v("Gracias. ")]), _vm._v("Thank you.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Victor E. Villaseñor    "), _c('br'), _vm._v("Rancho Villaseñor      "), _c('br'), _vm._v("Oceanside, California"), _c('br'), _vm._v("Spring 2001                 ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1660d68b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780061753923_Preface.vue
// module id = 69
// module chunks = 0